export default __webpack_public_path__ + "static/media/YE.4472dcff.svg";